import React, { Component, Fragment } from 'react';
import Header from '../../components/Header';
import UserAvatarEleg from '../../components/UserAvatarEleg';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import './index.scss';

class ElegibilityResponse extends Component {

  render() {

    const { flagElegivel, codServico, cobertura, carencia, nomeBenef, codBenef, registroANS, msgRetorno } = this.props.location.state;

    return (
      <Fragment>
        <Header class="title-center orange-gradient" name="Elegibilidade" />
        <UserAvatarEleg bgClass="UserAvatar" />
        <div className="CheckResponse">
          <div className="row">
            <div className="paragraph-blue">Carteirinha verificada com sucesso!</div>
            <div>Confira abaixo os dados verificados.</div>
          </div>

          <div className="CardElegibilty z-depth-4">
            <div className={`is-${flagElegivel ? 'valid' : 'invalid'}`}>
              <div className={`card-hat ${flagElegivel ? 'green-gradient' : 'red-gradient'}`}>
                <p>
                  {`${flagElegivel ? 'Este paciente está elegível' : 'Este paciente não está elegível'
                    }`}
                </p>
              </div>
              <div className="card-info">
                <div className="patient-name">
                  <span>Nome do beneficiário: </span>
                  <p>{nomeBenef}</p>
                </div>
                <div className="card-ci">
                  <span>Número da carteirinha: </span>
                  <span style={{ fontWeight: "normal" }}>{codBenef}</span>
                </div>
                <div className="card-ans">
                  <span>Registro ANS: </span>
                  <span style={{ fontWeight: "normal" }}>{registroANS}</span>
                </div>
                <div className="card-ans">
                  <span>Indicador de elegibilidade: </span>

                  {(() => {
                    if (flagElegivel) {
                      return (
                        <span style={{ fontWeight: "normal" }}><label htmlFor="eleg1" style={{ color: '#1acb9e', fontSize: '16px', fontfamily: "Roboto" }}>S</label>im</span>
                      )
                    } else {
                      return (
                        <span style={{ fontWeight: "normal" }}><label htmlFor="eleg2" style={{ color: '#F15151', fontSize: '16px', fontfamily: "Roboto" }}>N</label>ão</span>
                      )
                    }
                  })()}
                </div>

                {flagElegivel && codServico != 0 ? (
                  <div className="card-cobertura">
                    <span>Cobertura: </span>

                    {(() => {
                      if (cobertura) {
                        return (
                          <span style={{ fontWeight: "normal" }}><label htmlFor="eleg1" style={{ color: '#1acb9e', fontSize: '16px', fontfamily: "Roboto" }}>S</label>im</span>
                        )
                      } else {
                        return (
                          <span style={{ fontWeight: "normal" }}><label htmlFor="eleg2" style={{ color: '#F15151', fontSize: '16px', fontfamily: "Roboto" }}>N</label>ão</span>
                        )
                      }
                    })()}
                  </div>
                ) : null}

                {flagElegivel && codServico != 0 ? (
                  <div className="card-carencia">
                    <span>Carência: </span>

                    {(() => {
                      if (!cobertura) {
                        return (
                          <span style={{ fontWeight: "normal" }}>-</span>
                        )
                      } else if (carencia !== null && carencia != '01/01/0001') {
                        if (new Date(`${carencia.split('/')[2]}-${carencia.split('/')[1]}-${carencia.split('/')[0]} 00:00`) >= new Date()) {
                          return (
                            <span style={{ fontWeight: "normal" }}><label htmlFor="eleg1" style={{ color: '#1acb9e', fontSize: '16px', fontfamily: "Roboto" }}>S</label>im - {carencia}</span>
                          )
                        } else {
                          return (
                            <span style={{ fontWeight: "normal" }}>Sem carência</span>
                          )
                        }
                      } else {
                        return (
                          <span style={{ fontWeight: "normal" }}><label htmlFor="eleg2" style={{ color: '#F15151', fontSize: '16px', fontfamily: "Roboto" }}>N</label>ão</span>
                        )
                      }
                    })()}
                  </div>
                ) : null}

                <br />
                <div className="card-ans">
                  {msgRetorno}
                </div>
              </div>
            </div>
          </div>

          <div className="btn-enviar" style={{ marginTop: 12 }}>
            <Link to="/elegibilidade">
              <Button variant="contained" disableElevation>
                Verificar Nova Carteirinha
              </Button>
            </Link>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ElegibilityResponse;